import React from 'react';
import editIcon from "../../../assets/Images/edit (1).png";
import close from '../../../assets/Images/Request_Property/close.png';
import { getDocumentPreviewUrl } from '../../../utils/fileHelpers';
const File = ({ file, onDeleteFile, onEditFile, category }) => {
  return (
    <div className="file-container" style={{ position: 'relative' }}>
      <div className="file-actions" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
        <img onClick={(e) => {
          e.stopPropagation();
          onEditFile(file, category);
        }} src={editIcon} className="editIcon" alt="Edit" />
        <div
          className="file-remove-button221"
          onClick={(e) => {
            e.stopPropagation();
            onDeleteFile(category, file.id);
          }}
        >
          <img src={close} className="close-btn-in-editProfile" alt="Remove" />
        </div>

      </div>
      <iframe
        src={getDocumentPreviewUrl(file.file)}
        width="100%"
        height="80%"
        style={{ border: 'none' ,height:'40px' }}
        title="Document Viewer"
      />
    </div>
  );
};

export default File;

